import React from "react";

import GabianFlag from "../images/Gm-flag.png";
import NigerianFlag from "../images/Ng-flag.png";
import RwandanFlag from "../images/Rw-flag.png";
import senegalseFlag from "../images/Sg-flag.png";
import CamerooneanFlag from "../images/Cr-flag.png";
import Togo from "../images/Tg-flag.png";
import IvoryCoastFlag from "../images/Iv-flag.png";
import MozambigueFlag from "../images/Mz-flag.png";
import TafGlobalMap from "../images/map1.png";

const TafInAfrica = () => {
  return (
    <div>
      <section className="section-wrap split-section no-padding" id="countries">
        <div className="container-fluid">
          <div className="row split-section-flex-parent">
            <div
              className="split-section-img"
              title="countries details bac image"
            >
              <img
                className="lazy"
                src={TafGlobalMap}
                alt="TAF AFRICA FULLY UNDERSTANDS WHAT IT TAKES TO DELIVER A PROJECT."
              />
            </div>

            <div className="split-section-box flex-parent">
              <div className="split-section-inner">
                <h3>
                  TAF AFRICA GLOBAL FULLY UNDERSTANDS WHAT IT TAKES TO DELIVER A
                  PROJECT.
                </h3>
                <p className="split-section-text">
                  TAF Africa Global has a proven track record of consistently
                  delivering on every project embarked on over the past 30
                  years. We take pride in the fact that all our projects are
                  delivered in accordance with international construction and
                  engineering standards. TAF Africa Global offers every client a
                  1-year defect warranty on most finishes and a 5-year
                  structural warranty. TAF Africa Global is the turnkey solution
                  for affordable, quality and sustainable development. We are
                  able to achieve this feat as our model entails a bespoke
                  design and development of mechanical &amp; electrical
                  infrastructure, internal road networks, communal and
                  recreation areas, fully and semi-furnished homes – all within
                  the scope of a project.
                </p>

                <div className="progress-bars">
                  <h6 className="progress-title">
                    THE GAMBIA
                    <span className="progress-percent">
                      <img className="lazy" src={GabianFlag} alt="The Gambia" />
                    </span>
                  </h6>
                  <div className="progress-base" id="animated-bars">
                    <div
                      aria-valuemax="100"
                      aria-valuemin="0"
                      aria-valuenow="100"
                      className="progress-bar"
                      role="progressbar"
                    >
                      <span className="sr-only">Country, THE GAMBIA</span>
                    </div>
                  </div>
                  <h6 className="progress-title">
                    NIGERIA
                    <span className="progress-percent">
                      <img
                        className="lazy"
                        src={NigerianFlag}
                        alt="The Gambia"
                      />
                    </span>
                  </h6>
                  <div className="progress-base" id="animated-bars">
                    <div
                      aria-valuemax="100"
                      aria-valuemin="0"
                      aria-valuenow="100"
                      className="progress-bar"
                      role="progressbar"
                    >
                      <span className="sr-only">Country, NIGERIA</span>
                    </div>
                  </div>
                  <h6 className="progress-title">
                    RWANDA
                    <span className="progress-percent">
                      <img
                        className="lazy"
                        src={RwandanFlag}
                        alt="The Gambia"
                      />
                    </span>
                  </h6>
                  <div className="progress-base" id="animated-bars">
                    <div
                      aria-valuemax="100"
                      aria-valuemin="0"
                      aria-valuenow="100"
                      className="progress-bar"
                      role="progressbar"
                    >
                      <span className="sr-only">Country, RWANDA</span>
                    </div>
                  </div>
                  <h6 className="progress-title">
                    SENEGAL
                    <span className="progress-percent">
                      <img
                        className="lazy"
                        src={senegalseFlag}
                        alt="The Gambia"
                      />
                    </span>
                  </h6>
                  <div className="progress-base" id="animated-bars">
                    <div
                      aria-valuemax="100"
                      aria-valuemin="0"
                      aria-valuenow="100"
                      className="progress-bar"
                      role="progressbar"
                    >
                      <span className="sr-only">Country, SENEGAL</span>
                    </div>
                  </div>
                  <h6 className="progress-title">
                    CAMEROON
                    <span className="progress-percent">
                      <img
                        className="lazy"
                        src={CamerooneanFlag}
                        alt="The Gambia"
                      />
                    </span>
                  </h6>
                  <div className="progress-base" id="animated-bars">
                    <div
                      aria-valuemax="100"
                      aria-valuemin="0"
                      aria-valuenow="100"
                      className="progress-bar"
                      role="progressbar"
                    >
                      <span className="sr-only">Country, CAMEROON</span>
                    </div>
                  </div>
                  <h6 className="progress-title">
                    TOGO
                    <span className="progress-percent">
                      <img className="lazy" src={Togo} alt="The Gambia" />
                    </span>
                  </h6>
                  <div className="progress-base" id="animated-bars">
                    <div
                      aria-valuemax="100"
                      aria-valuemin="0"
                      aria-valuenow="100"
                      className="progress-bar"
                      role="progressbar"
                    >
                      <span className="sr-only">Country, TOGO</span>
                    </div>
                  </div>
                  <h6 className="progress-title">
                    IVORY COAST
                    <span className="progress-percent">
                      <img
                        className="lazy"
                        src={IvoryCoastFlag}
                        alt="The Gambia"
                      />
                    </span>
                  </h6>
                  <div className="progress-base" id="animated-bars">
                    <div
                      aria-valuemax="100"
                      aria-valuemin="0"
                      aria-valuenow="100"
                      className="progress-bar"
                      role="progressbar"
                    >
                      <span className="sr-only">Country, IVORY COAST</span>
                    </div>
                  </div>
                  <h6 className="progress-title">
                    MOZAMBIGUE
                    <span className="progress-percent">
                      <img
                        className="lazy"
                        src={MozambigueFlag}
                        alt="The Gambia"
                      />
                    </span>
                  </h6>
                  <div className="progress-base" id="animated-bars">
                    <div
                      aria-valuemax="100"
                      aria-valuemin="0"
                      aria-valuenow="100"
                      className="progress-bar"
                      role="progressbar"
                    >
                      <span className="sr-only">Country, MOZAMBIGUE</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="section-wrap promo-section-2 bg-img animate"
        id="about"
        style={{
          height: "600px",
          backgroundPosition: "top",
        }}
      ></section>
    </div>
  );
};
export default TafInAfrica;
